var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccessIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142,
  height: 137,
  fill: "none",
  viewBox: "0 0 142 137",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#43BE7D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 9,
  d: "M137.071 62.655v5.882c-.008 13.785-4.621 27.2-13.152 38.241s-20.522 19.118-34.185 23.027a68.17 68.17 0 0 1-41.631-1.338c-13.365-4.778-24.776-13.607-32.53-25.172S4.133 78.05 5.071 64.294c.937-13.756 6.445-26.85 15.702-37.33S42.542 9.181 56.44 6.144c13.898-3.039 28.438-1.649 41.452 3.962m39.18 7.288L71 81.386 51.179 62.208"
})));
export { SvgSuccessIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/successIcon.svg";